<div *ngIf="notEnoughAmount">
    <div class="overlay-no-data">
        <div class="notify-no-data">
            <div class="notify-text">
                Insufficient funds available,
                <br> please fund your account
            </div>
            <div class="d-flex">
                <button class="btn btn-block btn-greengo mx-auto" (click)="fundAccount()">Fund my account</button>
            </div>
        </div>
    </div>
</div>

<div [class.opacity-4]="notEnoughAmount">
    <div [ngClass]="{
        'dialog-title text-fw-700': sendPaymentType === sendPaymentTypeEnum.SendPaymentFromTrade,
        'panel-title': sendPaymentType === sendPaymentTypeEnum.SendPaymentDashboard
    }">
        Send Payment Instruction
    </div>
    <div class="client-dashboard-session">
        <div class="col-12 p-0">
            <form [formGroup]="sendPaymentForm" class="send-payment-form">
                <div class="content col-12">

                    <div class="row mg-b-20">
                        <div class="top-text col-12">How much would you like to send?</div>
                        <div class="d-flex col-12 px-0">
                            <div class="currency currency-amount mat-border col-4" [ngClass]="{
                          'is-valid': sendPaymentForm.get('currency').valid && sendPaymentForm.get('currency').touched,
                          'is-invalid': !sendPaymentForm.get('currency').valid && sendPaymentForm.get('currency').touched
                        }">
                                <mat-form-field class="mat-label-error" [ngClass]="sendPaymentForm.get('currency').value ? 'not-empty' : ''">
                                    <mat-select panelClass="custom-mat-panel" placeholder="Currency" formControlName="currency" (selectionChange)="changeCurrency($event)"
                                        [disabled]="sendPaymentType === 2">
                                        <mat-select-trigger>
                                            <ng-container *ngIf="!sendPaymentForm.get('currency').value; else showCurrency">
                                                -----
                                            </ng-container>
                                            <ng-template #showCurrency>
                                                <div [innerHTML]="sendPaymentForm.get('currency').value | transformCurrency : currencies : 'currencyCode'"></div>
                                            </ng-template>
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let currency of currencies" [value]="currency.id">
                                            <span [class]="currency.currencyCode | flagIcon"></span>&nbsp;
                                            <span>{{ currency.currencyCode }} </span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="amount currency-amount mat-border col-8" [ngClass]="{
                          'is-valid': sendPaymentForm.get('amount').valid && sendPaymentForm.get('amount').touched,
                          'is-invalid': !sendPaymentForm.get('amount').valid && sendPaymentForm.get('amount').touched
                        }">
                                <mat-form-field class="mat-label-error" [ngClass]="sendPaymentForm.get('amount').value ? 'not-empty' : ''">
                                    <input matInput autocomplete="off" value="" npInputMask [options]="{
                                      numeral: true,
                                      numeralIntegerScale: 255
                                    }" formControlName="amount" type="text" placeholder="Amount" (blur)="changeAmount()"
                                    />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="row mg-b-20">
                        <div class="col-12 col-md-7 px-0">
                            <div class="d-flex top-text has-icon align-items-center">
                                Who would you like to pay?
                                <div class="img ml-auto">
                                    <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-white.svg" alt="" />
                                    <div class="send-payment-tooltip tooltip-left">
                                        <p class="first-line">These are the beneficiaries
                                            <br>that have already been
                                            <br>added to your account.</p>
                                        <p>If paying a new beneficiary,
                                            <br>select ‘New beneficiary’ and
                                            <br>enter their details on the
                                            <br>following screens.</p>
                                    </div>
                                </div>

                            </div>
                            <div class="d-flex mat-border" [ngClass]="{
                          'is-valid': sendPaymentForm.get('recipient').valid && sendPaymentForm.get('recipient').touched,
                          'is-invalid': !sendPaymentForm.get('recipient').valid && sendPaymentForm.get('recipient').touched
                        }">
                                <mat-form-field class="no-padding">
                                    <input type="text" formControlName="recipient" matInput [matAutocomplete]="auto">
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectRecipient($event)">
                                        <mat-option [value]="{id: '', name: 'Add new beneficiary'}" [class.show-border]="(filteredRecipientObservable | async)?.length > 0">Add new beneficiary</mat-option>
                                        <mat-option *ngFor="let option of filteredRecipientObservable | async"
                                        [value]="option">
                                        {{ option.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="col-12 col-md-5 pr-0 date-select">
                            <div class="d-flex top-text has-icon align-items-center">
                                On this date
                                <div class="img ml-auto">
                                    <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-white.svg" alt="" />
                                    <span class="send-payment-tooltip tooltip-date tooltip-left">This is the date you wish to
                                        <br>send the payment on.</span>
                                </div>
                            </div>
                            <div class="col-12 mat-border" [ngClass]="{
                          'is-valid': sendPaymentForm.get('paymentDate').valid && sendPaymentForm.get('paymentDate').touched,
                          'is-invalid': !sendPaymentForm.get('paymentDate').valid && sendPaymentForm.get('paymentDate').touched
                        }">
                                <mat-form-field class="payment-date-value mat-label-error">
                                    <input matInput [matDatepicker]="paymentDatePicker" formControlName="paymentDate" [min]="minDate" />
                                    <mat-datepicker-toggle matSuffix [for]="paymentDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker panelClass="greengo" #paymentDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="row mg-b-20">
                        <div class="col-12 px-0">
                            <div class="top-text">Reason for payment</div>
                            <div class="mat-border" [ngClass]="{
                          'is-valid': (sendPaymentForm.get('reasonPayment').valid && sendPaymentForm.get('reasonPayment').touched && sendPaymentForm.get('reasonPayment').value.name !== 'Others') ||
                          (getReasonPayment.value && getReasonPayment.value.name === 'Others' && sendPaymentForm.get('reasonPaymentOther') && sendPaymentForm.get('reasonPaymentOther').valid && sendPaymentForm.get('reasonPaymentOther').touched),
                          'is-invalid': (!sendPaymentForm.get('reasonPayment').valid && sendPaymentForm.get('reasonPayment').touched) ||
                          (getReasonPayment.value && getReasonPayment.value.name === 'Others' && sendPaymentForm.get('reasonPaymentOther') && !sendPaymentForm.get('reasonPaymentOther').value && sendPaymentForm.get('reasonPaymentOther').touched)
                        }">
                                <mat-form-field class="mat-label-error">
                                    <mat-select panelClass="custom-mat-panel" formControlName="reasonPayment" placeholder="Please select" (selectionChange)="selectReasonChange($event)">
                                        <mat-option *ngFor="let reason of rfpList" [value]="reason">
                                            {{ reason.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <ng-container *ngIf="getReasonPayment.value.name === 'Others'">
                                    <mat-form-field class="reason-paymnet-other mat-label-error" [class.mat-form-field-invalid]="sendPaymentForm.get('reasonPaymentOther') && !sendPaymentForm.get('reasonPaymentOther').value && sendPaymentForm.get('reasonPaymentOther').touched">
                                        <span matPrefix>Other |&nbsp;</span>
                                        <input matInput formControlName="reasonPaymentOther" placeholder="Please enter your reason here" />
                                    </mat-form-field>

                                    <div class="col-12 pl-0 error-message" *ngIf="sendPaymentForm.get('reasonPaymentOther') && sendPaymentForm.get('reasonPaymentOther').hasError('pattern')">
                                      <np-swift-character-message></np-swift-character-message>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
                        <div class="col-4 pl-0" *ngIf="sendPaymentType === 2">
                            <button class="btn btn-block btn-lg btn-greengo-o" (click)="goBack()">
                                Back
                            </button>
                        </div>
                        <div class="col-4  px-0" [ngClass]="{
                            'offset-8': sendPaymentType !== 2,
                            'offset-4': sendPaymentType === 2
                          }">
                            <button class="btn btn-block btn-lg  mg-b-10" (click)="nextTab()" [ngClass]="{
                          'btn-greengo': sendPaymentForm.valid,
                          'btn-inactive': !sendPaymentForm.valid
                        }" npFocusOutClicked>
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
